import { QueryKeyTypes } from "../../../assets/types/common";
import { Constants } from "../../../assets/utils/lib/constants";
import { LookupDto } from "../../../assets/utils/lib/lookupDto";

export namespace ViewProps{

    export interface BannerTypeLookupProps {
        bannerType?: LookupDto[] | undefined;
    }

    export const UserQueryKeys: Record<QueryKeyTypes, string> = {
        [QueryKeyTypes.None]: Constants.emptyString,
        [QueryKeyTypes.Get]: "bannerQuery",
        [QueryKeyTypes.Grid]: "bannerGridQuery",
        [QueryKeyTypes.Lookup]: "bannerlookupsQuery",
        [QueryKeyTypes.GetAll]: Constants.emptyString,
    }
}
